/**
 * Breakpoints e largura do palco no modo de edição mobile.
 * @package gepetto-frontend
 */

/** Mesmo valor usado no CSS de exportação (`@media (max-width: …)`). */
export const BREAKPOINT_MOBILE_MAX = 767;

/** Largura visual do palco ao editar em modo mobile (px). */
export const MOBILE_STAGE_WIDTH_PX = 390;

export const EDIT_BREAKPOINT_DESKTOP = 'desktop';
export const EDIT_BREAKPOINT_MOBILE = 'mobile';
